import React, { useContext, useEffect, useState } from "react";
import field from "../../img/field.png";
import { Formation } from "../../interfaces/Formation.Interface";
import { Player } from "../../interfaces/Player.Interface";
import { DndProvider } from "react-dnd";
import MultiBackend from "react-dnd-multi-backend";
import HTML5toTouch from "react-dnd-multi-backend/dist/esm/HTML5toTouch";
import PlayerDropComponent from "./PlayerDrop.Component";
import TeamCardPlayerComponent from "./TeamCardPlayer.Component";
import { firebaseContext } from "../../contexts/FirebaseContext";
import { DB_REF } from "../../constants/DB";
import "./TeamSheet.Styles.scss";
import PlayerPoolComponent from "./PlayerPool.Component";
import { v4 } from "uuid";
import { dateToFirestore } from "../../services/DateToFirestore";
import { Button, Radio, RadioGroup, Spinner } from "@blueprintjs/core";

interface Props {
  formation: Formation;
  formation2: Formation;
  date: Date;
}

export default function EditTeamSheetComponent(props: Props) {
  const [playerPool, setPlayerPool] = useState<Player[]>([]);
  const [loading, setLoading] = useState(false);
  const firebase = useContext(firebaseContext);
  const [players, setPlayers] = useState<string[]>([]);
  const [msg, setMsg] = useState("");
  const [display, setDisplay] = useState("first");

  useEffect(() => {
    const getPlayers = async () => {
      try {
        const data = await firebase
          .firestore()
          .collection(DB_REF.players)
          .where("active", "==", true)
          .get();
        setPlayerPool([]);
        data.forEach((ele) => {
          setPlayerPool((old) => [...old, ele.data() as any]);
        });
      } catch (err) {
        console.log(err);
      }
    };
    const getTeamcard = async () => {
      try {
        const formationData = await firebase
          .firestore()
          .collection(DB_REF.teamCards)
          .doc(dateToFirestore(props.date))
          .get();
        if (formationData.exists) {
          setPlayers(formationData.data()!.players);
        } else {
          setPlayers([]);
        }
      } catch (err) {
        console.log(err);
      }
    };
    getTeamcard();
    getPlayers();
  }, [firebase, props.date]);

  const getPlayerFromId = (id: string) => {
    for (const e of playerPool) {
      if (e.playerId === id) {
        return e;
      }
    }

    return null;
  };

  const renderPlayers = (start: number, count: number) => {
    const playerData: JSX.Element[] = [];

    for (let i = start; i < start + count; i++) {
      const ele = renderPosition(players, i);
      playerData.push(ele);
    }

    return playerData;
  };

  const setPosition = (position: number, id: string) => {
    setPlayers((old) => {
      let newP = [...old];

      for (let i = 0; i < newP.length; i++) {
        if (newP[i] === id) {
          newP[i] = "";
        }
      }

      newP[position] = id;
      return newP;
    });
  };

  const renderPosition = (players: string[], position: number) => {
    const player = players[position];
    const p = getPlayerFromId(player);
    if (p) {
      return <TeamCardPlayerComponent key={v4()} player={p} />;
    } else {
      return (
        <PlayerDropComponent
          key={v4()}
          setPosition={setPosition}
          position={position}
        />
      );
    }
  };

  const removePlayer = (id: string) => {
    setPlayers((old) => {
      let data = [...old];
      for (let i = 0; i < data.length; i++) {
        if (data[i] === id) {
          data[i] = "";
        }
      }
      return data;
    });
  };

  const { foward, defend, midfield } = props.formation;
  const { formation2 } = props;

  const saveFormation = async () => {
    let pData = [];

    for (let i = 0; i < players.length; i++) {
      if (players[i]) {
        pData[i] = players[i];
      } else {
        pData[i] = null;
      }
    }
    try {
      setLoading(true);
      await firebase
        .firestore()
        .collection(DB_REF.teamCards)
        .doc(dateToFirestore(props.date))
        .set({
          date: dateToFirestore(props.date),
          formation: props.formation,
          players: pData,
        });
      setMsg("Save Complete");
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const renderTeam1 = () => {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className="team-sheet-container-edit">
          <div className="field">
            <img src={field} alt="" />
          </div>
          <div className="positions">
            <div className="fowards">
              {renderPlayers(midfield + defend + 1, foward)}
            </div>
            <div className="midfielders">
              {renderPlayers(defend + 1, midfield)}
            </div>
            <div className="defenders">{renderPlayers(1, defend)}</div>
            <div className="goalkeeper">{renderPlayers(0, 1)}</div>
          </div>
        </div>
      </div>
    );
  };

  const renderTeam2 = () => {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className="team-sheet-container-edit">
          <div className="field">
            <img src={field} alt="" />
          </div>
          <div className="positions">
            <div className="fowards">
              {renderPlayers(
                formation2.midfield + formation2.defend + 11,
                formation2.foward
              )}
            </div>
            <div className="midfielders">
              {renderPlayers(formation2.defend + 11, formation2.midfield)}
            </div>
            <div className="defenders">
              {renderPlayers(11, formation2.defend)}
            </div>
            <div className="goalkeeper">{renderPlayers(11, 1)}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <DndProvider options={HTML5toTouch} backend={MultiBackend as any}>
      <div
        style={{ display: "flex", justifyContent: "center", paddingBottom: 40 }}
      >
        {loading ? (
          <Spinner />
        ) : (
          <Button
            text="Save Formation"
            intent="success"
            onClick={saveFormation}
          />
        )}
      </div>
      <div style={{ padding: 10, color: "greenyellow", textAlign: "center" }}>
        {msg}
      </div>
      <div
        style={{ display: "flex", justifyContent: "center", paddingBottom: 20 }}
      >
        <RadioGroup
          label="Select team to edit"
          onChange={(e) => setDisplay((e.target as any).value)}
          selectedValue={display}
        >
          <Radio label="First team" value="first" />
          <Radio label="Second team" value="second" />
        </RadioGroup>
      </div>
      <PlayerPoolComponent
        removePlayer={removePlayer}
        playerPool={playerPool}
        players={players}
      />

      {display === "first" && renderTeam1()}
      {display === "second" && renderTeam2()}
    </DndProvider>
  );
}
